import React, { PropsWithChildren } from 'react';
import { Link } from '@common/components';
import { buildDialogUrl } from '@common/services';
import { useCurrentMembership } from '@identity/hooks';

type TriggerProps = {
  applicationId: string;
  applicationState: string;
};

export function SubmittalPacketChangeRequestDrawerTrigger({
  applicationId,
  applicationState,
  children,
}: PropsWithChildren<TriggerProps>) {
  const currentMembership = useCurrentMembership();

  const canUserSubmitChangeRequest =
    currentMembership.canSubmitSubmittalPacketChangeRequest;

  if (!isValidState(applicationState) || !canUserSubmitChangeRequest) {
    return <></>;
  }

  return (
    <Link
      to={buildDialogUrl('submittal-packet-change-request-drawer', {
        overlap: true,
        props: { applicationId },
      })}
    >
      {children}
    </Link>
  );
}

function isValidState(state: string) {
  return ['submitted'].includes(state);
}
